export const surveyKey = "user_survey";
export const timeBeforeShowingSurvayAgain = 2592000000;
